import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-control-history',
  templateUrl: './control-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./control-history.component.scss']
})
export class ControlHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
